import { render, staticRenderFns } from "./FiltersTemplate.vue?vue&type=template&id=560366c8"
import script from "./FiltersTemplate.vue?vue&type=script&lang=js"
export * from "./FiltersTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports